export enum SpinnerType {
  Loading = "Loading",
  Thinking = "Thinking",
}
